export default __webpack_public_path__ + "5c7f2aef63eda28a56ad653c080308e7.svg";